import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    ChangeDetectorRef,
    Input
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
    ActivityDaysServiceProxy,
    PlantsServiceProxy,
    AllocatedPlantDto,
    AllocatePlantForActivityDayInput,
    UpdateAllocatePlantListForActivityDayInput,
    UpdateAllocatedPlantHoursForActivityDayInput,
    PlantDto,
    CreateOrEditPlantDto,
} from '@shared/service-proxies/service-proxies';
import { stringify } from 'querystring';
import { guid } from '@fullcalendar/common';

@Component({
    selector: 'app-assign-plants-table',
    templateUrl: './assign-plants-table.component.html',
    styleUrls: ['./assign-plants-table.component.less']
})
export class AssignPlantsTableModelComponent extends AppComponentBase {
    @Input() componentMode: 'allocationSheet' | 'default' = 'default';
    @Input() allowedPlants: any;
    @Input() allocatedPlants: any;
    @Input() activityDayId: string;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
    @Input() controlDisabled: boolean;
    @Input() anyResourceSelected: boolean;

    @ViewChild('plantSelectorTable') plantSelectorTable: ModalDirective;

    saving: boolean = false;
    addManualPlant: boolean =false;
    manualPlantSaved: boolean = true;
    fullUserName = '';

    @Output()
    onAssignedCounterUpdate: EventEmitter<number> = new EventEmitter<number>();

    public filteredPlants: Array<any> = [];
    public addedPlants: Array<PlantDto> = [];
    public addedManualPlants : Array<CreateOrEditPlantDto> = [];
    public addedManualPlant : CreateOrEditPlantDto;
    public currentAllocatedPlant: any;
    public adddedPlantSaving : boolean = false;
    constructor(
        injector: Injector,
        private _activityDaysServiceProxy: ActivityDaysServiceProxy,
        private _plantsServiceProxy: PlantsServiceProxy,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
    }
    addManualFlagUpdate(): void{
        this.addManualPlant= !this.addManualPlant;
        this.cdr.detectChanges();
    }

    addAddManual(): void{
        this.addedManualPlant = new CreateOrEditPlantDto({
            isManualPlant: true,
            orderNumber: "",
            supplierName: "",
            location: "",
            resource: "",
            activity: "",
            serialNumber: "",
            extendedOrderDescription: "",
            description: "",
            activityDescription: "",
            contractCode: "",
            contractDescription: "",
            maximumHireRate: 0,
            quantityOnHire: 0,
            id: "",
            plantID : "",
            plantOwner : "",
            plantCategory : "",
            plantType : "",
            manufacturer : "",
            yom : "",
            enginePowers : "",
            engine : ""
            });

        this.manualPlantSaved = false;
        this.addedManualPlants.push(this.addedManualPlant);
        this.cdr.detectChanges();
    }

    saveAddedPlant() {
        this.manualPlantSaved = false;
        var validation = true;
        //Duplicate chack
        this.addedManualPlants.forEach(plant => {
            var filterPlantFind = this.filteredPlants.find(p=>p.serialNumber==plant.serialNumber);
            var manualPlantFind = this.addedManualPlants?.filter(p=>p.serialNumber==plant.serialNumber);

            if(filterPlantFind != null)
            {
                plant.serialNumber = "";
                validation = false;
            }
            if(manualPlantFind.length > 1)
            {
                if(plant.id == null || plant.id == "")
                {
                    plant.serialNumber = "";
                }
                validation = false;
            }
        });

        if(!validation)
        {
            this.message.info(this.l('DuplicateSerialNumber'), this.l('DuplicateManualPlant'));
        }

        var invalidPlants = this.addedManualPlants.find(p=> (p.serialNumber == ""));
        if(invalidPlants != null && validation)
        {
            validation = false;
            this.message.info(this.l('ValidationError'), this.l('ManualPlant'));
        }

        //All validation check
        if(validation)
        {
            this._plantsServiceProxy
            .createOrEditManual(this.addedManualPlants)
            .subscribe((retrunAddedManualPlants) => {
            this.addedManualPlants = retrunAddedManualPlants;
            this.manualPlantSaved = true;
            this.selectPlantManual(this.addedManualPlants);
                if(this.manualPlantSaved)
                {
                    this.notify.info(this.l('SavedSuccessfully'));
                    this.plantSelectorTable.hide();
                }
            });
        }
        this.cdr.detectChanges();
    }

    ngAfterViewInit() {
        this.setInitialPlantsSelectorValue();
    }

    isAllocationSheet() {
        return this.componentMode === 'allocationSheet';
    }


    selectPlantManual(plants : CreateOrEditPlantDto[]) {
        var params = [];

        plants.forEach(plant => {
            if(plant.id == null || plant.id == "")
            {
                this.manualPlantSaved = false;
                plant.serialNumber = "";
            }
            else
            {
                var isAlardyAdd = this.currentAllocatedPlant.allocatedPlants.find(p=>p.plantId == plant.id);
                if(isAlardyAdd == null)
                {
                    const param = new AllocatePlantForActivityDayInput({
                        activityDayId: this.activityDayId,
                        plant: new AllocatedPlantDto({
                            actualHours: 0,
                            plantId: plant.id,
                        }),
                    });
                    params.push(param);
                }
                else
                {
                    isAlardyAdd.plantDetails= plant;
                }

            }
        });

        if(params.length > 0)
        {
            //Saving in bluk
            this._activityDaysServiceProxy.allocatePlants(params).subscribe(() => {
                this._activityDaysServiceProxy
                    .getMyActivityDayForEdit(this.activityDayId)
                    .subscribe((data) => {
                        params.forEach(param => {

                            var plant = plants.find(p=>p.id == param.plant.plantId);
                            this.currentAllocatedPlant.allocatedPlants.push({
                                plantDetails: {...plant},
                                actualHours: 0,
                                plantId: plant.id,
                                userFullName : this.fullUserName,
                            });
                        });
                        this.updateTotals();
                        this.cdr.detectChanges();
                    });
            });
        }

    }

    selectPlant(plant, selected) {
        let selectedPlant = this.filteredPlants.find((p) => p.id == plant.id);
        selectedPlant.selected = selected;
        if(selected){
            const params = new AllocatePlantForActivityDayInput({
                activityDayId: this.activityDayId,
                plant: new AllocatedPlantDto({
                    actualHours: 0,
                    plantId: plant.id,
                }),
            });

            this._activityDaysServiceProxy.allocatePlant(params).subscribe(() => {
                this._activityDaysServiceProxy
                    .getMyActivityDayForEdit(this.activityDayId)
                    .subscribe((data) => {
                        this.currentAllocatedPlant.allocatedPlants.push({
                            plantDetails: {...plant},
                            actualHours: 0,
                            plantId: plant.id
                        });
                        abp.event.trigger('app.evt.activityChanged');
                        this.updateTotals();

                    });
            });
        }else{
            this._activityDaysServiceProxy
            .removeAllocatedPlant(this.activityDayId, plant.id)
            .subscribe(() => {
                this.currentAllocatedPlant.allocatedPlants = this.currentAllocatedPlant.allocatedPlants?.filter(c => c.plantId != plant.id);
                this.updateTotals();
            });
        }
        this.cdr.detectChanges();
    }


    show(): void {
        this.plantSelectorTable.show();
    }

    showError(): boolean {
        const selectedPlant = this.getSelectedPlant();
        const total = selectedPlant && selectedPlant.length >0 ? selectedPlant.map(x=>x.actualHours).reduce((a, b) => { return a + b }):0;
        return total<=0
    }

    save(): void {
        this.saving = true;
    }

    close(): void {
        if(this.addManualPlant)
        {
            this.saveAddedPlant();
        }
        else
        {
            this.plantSelectorTable.hide();
        }
    }

    ClearRecent(): void {

        this._activityDaysServiceProxy.clearAllocatedPlantRecent()
        .subscribe(() => {
            this.filteredPlants.forEach(plant => {
                plant.wasRecentlyAssigned = false;
            });

            this.cdr.detectChanges();
        });
    }

    getUserToolTip(plant: any): string
    {
        return this.l('ManualPlantToolTip') + plant.userFullName;
    }

    getPlantDeleteToolTip(plant: any): string
    {
        return this.l('DeletePlant') + ' '
        + plant.plantDetails.description + ' ('
        + plant.plantDetails.serialNumber + ')';
    }

    getSelectedPlant() {
        var result= this.currentAllocatedPlant && this.currentAllocatedPlant.allocatedPlants ? this.currentAllocatedPlant.allocatedPlants : [];
        return result;
    }

    setInitialPlantsSelectorValue() {

        this.filteredPlants = this.allowedPlants.map((p) => {
            let selected = this.allocatedPlants.allocatedPlants.some((c) => c.plantId == p.id) || false;
            return { ...p, selected,  filterShow: true};
        });

        this.currentAllocatedPlant = { ...this.allocatedPlants };

        //Manual Item loaded
        this._plantsServiceProxy.getManualAddedPlantsByActivityId(this.currentAllocatedPlant.allocatedPlants)
        .subscribe((retrunAddedManualPlants) => {
          this.addedManualPlants = retrunAddedManualPlants;
          this.manualPlantSaved = true;
        });

        this.fullUserName = this.appSession.user.name + " " + this.appSession.user.surname;

        this.updateTotals();
        this.cdr.detectChanges();
    }

    filteredPersonnelList(recent){
        if(recent){
            let filtered = this.filteredPlants?.filter(p => p.wasRecentlyAssigned && p.filterShow );
            return filtered;
        }
        let filtered = this.filteredPlants?.filter(p => p.filterShow);
        return filtered;
    }

    updateAllocatedPlantList(event) {
        if(event.target.value){
			if(event.target.value < 1 || event.target.value > 24) {
                this.notify.error('Hours value only allowed between 1 to 24');
                return;
            }
            const params = new UpdateAllocatePlantListForActivityDayInput({
                activityDayId: this.activityDayId,
                plants: [...this.currentAllocatedPlant.allocatedPlants].map((item) => {
                    return new AllocatedPlantDto({
                        actualHours: item.actualHours || 0,
                        plantId: item.plantId,
                    });
                }),
            });

            this._activityDaysServiceProxy
                .updateAllocatePlantList(params)
                .subscribe(() => {
                    this.updateTotals();
                    abp.event.trigger('app.evt.activityChanged');
                });
        }

    }

    updateTotals() {
        let plantSum = 0;
        this.currentAllocatedPlant.allocatedPlants.forEach(
            (item) => (plantSum += parseInt(item.actualHours))
        );
        this.onAssignedCounterUpdate.emit(plantSum);
    }

    removeManualPlantItem(currentItem: CreateOrEditPlantDto) {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                if(currentItem.id == null || currentItem.id == "")
                {
                    var indexvalue= this.addedManualPlants.indexOf(currentItem);
                    this.addedManualPlants.splice(indexvalue,1);
                    this.cdr.detectChanges();
                }
                else
                {
                    this.message.info(this.l('SavedPlantsCouldnotDeleted'), this.l('SavedManualPlant'));
                }
            }
        });
    }

    removeItem(plantId: string) {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._activityDaysServiceProxy
                    .removeAllocatedPlant(this.activityDayId, plantId)
                    .subscribe(() => {
                        this.currentAllocatedPlant.allocatedPlants = this.currentAllocatedPlant.allocatedPlants?.filter(
                            (plant) => plant.plantId != plantId
                        );
                        var plantDetail = this.filteredPlants.find(c=> c.id == plantId);
                        plantDetail.selected = false;
                        this.updateTotals();
                        abp.event.trigger('app.evt.activityChanged');
                    });

                this.cdr.detectChanges();
            }
        });
    }

    filtersChange(filters) {
        this.filteredPlants.forEach(f=>{
            let hide = false;
            if(filters.filterText && !(
                f.description && f.description.toLowerCase().includes(filters.filterText.toLowerCase()) ||
                f.serialNumber && f.serialNumber.toLowerCase().includes(filters.filterText.toLowerCase()) )){
                    hide = true;
            }
            if(!hide && (filters.location && filters.location.locationName && !(filters.location.locationName == f.location))){
                hide = true;
            }
            if(!hide && (filters.supplier && filters.supplier.supplierName && !(filters.supplier.supplierName == f.supplierName))){
                hide = true;
            }

            f.filterShow = !hide;
        });
        this.cdr.detectChanges();
    }

    isInvalidSerialNumber(currentItem: CreateOrEditPlantDto): boolean
    {
        if(currentItem.serialNumber == "")
        {
            return false;
        }
        return true;
    }

    checkSavedManual(currentItem: CreateOrEditPlantDto): boolean
    {
        if(currentItem.id == null && currentItem.id == "")
        {
            return true;
        }
        return false;
    }
    checkFilteredPlantNull(data) {
        let sr = '';
        data.forEach(plant=>{
            if(!plant.wasRecentlyAssigned && plant.filterShow) {
                sr = 'record_found';
            }
        })
        if(sr == 'record_found') {
            return false;
        } else {
            return true;
        }
    }
}
